// src/pages/AboutPage.jsx
import React from 'react';
import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import './AboutPage.css';
import PublicHeader from '../../Layout/PublicHeader';
import Footer from '../../Layout/VerticalLayout/Footer';

export default function AboutPage() {
  return (
    <>
      <PublicHeader />
      <Container className="about-page py-5">
        <Row>
          <Col>
            <Breadcrumb>
              <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
              <BreadcrumbItem active>About Us</BreadcrumbItem>
            </Breadcrumb>
            <h2 className="page-title mb-4">About Us</h2>
          </Col>
        </Row>

        {/* Our Mission */}
        <Row className="mb-5">
          <Col md={{ size: 8, offset: 2 }}>
            <h4 className="section-heading">Our Mission</h4>
            <p className="section-text">
              Pokémon Radiance is an online Pokémon RPG designed to deliver an immersive, community-driven experience. Our goal is
              to blend classic Pokémon gameplay with a dynamic economy of variant Pokémon, live events, and real-time collaboration.
            </p>
          </Col>
        </Row>

        {/* Credits */}
        <Row className="mb-5">
          <Col md={{ size: 8, offset: 2 }}>
            <h4 className="section-heading">Credits</h4>
            <ul className="credits-list">
              <li><strong>Artwork & Resources:</strong> Mooty</li>
              <li><strong>Discord Setup & Support:</strong> Joe</li>
              <li><strong>Beta Testers:</strong> Thank you to all our testers for exhaustive gameplay testing, bug reports, and feedback.</li>
            </ul>
          </Col>
        </Row>

        {/* Legal Info */}
        <Row>
          <Col md={{ size: 8, offset: 2 }}>
            <h4 className="section-heading">Legal Information</h4>
            <p className="section-text">
              Pokémon Radiance is a fan-made, non-profit project not affiliated with, endorsed by, or sponsored by Gamefreak, Nintendo, Creatures, or any rights holder of Pokémon.
              All Pokémon-related trademarks and copyrights belong to their respective owners.
            </p>
            <p className="section-text">
              By logging in, you acknowledge that you have read and agree to these terms. This game is provided "as is" without warranties, and its creators are
              not liable for any claims arising from its use.
            </p>
            <p className="section-text">
              We encourage all players to support the official Pokémon games and merchandise to help sustain the franchise.
            </p>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
